export const roleOptions = [
  { value: "hr", label: "HR" },
  { value: "developer", label: "Developer" },
  { value: "project_manager", label: "Project Manager" },
  { value: "marketing", label: "Marketing" },
  { value: "business_operation", label: "Business Operation" },
  { value: "designer", label: "Designer" },
  { value: "client", label: "Client" },
]
